// @flow

import type { Node } from "react";
import React from "react";

import JsonPageRenderer from "@/utils/JsonPageRenderer/JsonPageRenderer";
import type { ItemRenderer, PageItem } from "@/utils/JsonPageRenderer/types";

/**
 * The allowed HTML tags that may be rendered.
 *
 * @type {string[]}
 */
const allowedTags = ["h1", "h2", "h3", "h4", "h5", "span", "div"];

interface TextPageItem extends PageItem {
    props: {
        [string]: any,
        tag: string,
        className?: string,
        text: string,
    };
}

class TextRenderer implements ItemRenderer<TextPageItem> {
    render(context: JsonPageRenderer, item: TextPageItem): Node {
        const tag = item.props.tag;
        // Check if the tag is in the allowed tags list, throw an error if not.
        if (!allowedTags.includes(tag)) {
            throw new Error(
                `TextRender only allows the following tags: ${allowedTags.join(
                    ", ",
                )}`,
            );
        }

        // Use the low-level react API to create a node by its tag name
        // Would be nice to have something similar to vue's <component :is="tag" />
        // (https://vuejs.org/v2/guide/components.html#Dynamic-Components)
        return React.createElement(
            tag,
            {
                key: item.id,
                className: item.props.className,
            },
            item.props.text,
        );
    }

    match(item: PageItem): TextPageItem | null {
        if (item.type === "text") {
            return item;
        }
        return null;
    }
}

export default TextRenderer;
